import React from "react";
import { useBusStop } from "modules/api";

export const BusStopName: React.FC<{ id: string }> = ({ id }) => {
  const { data } = useBusStop(id, { suspense: true });
  return <>{data?.name || null}</>;
};
